<div class="zn-step-content-sections">
  <div [class]="originalSectionClass()">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ sectionTitleKey() | abpLocalization }}</h5>
          <p>{{ sectionDescriptionKey() | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      @if (!confirmedOriginalStand()) {
        <div class="zn-step-content-section-layout">
          <div class="zn-step-content-section-layout">
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Fields.OriginalStand') | abpLocalization }}</p>
              <p class="subtitle">{{ selectedStand()?.name ?? '-----' }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Fields.OriginalArea') | abpLocalization }}</p>
              <p class="subtitle">{{ formatArea(originalStandArea()) }}</p>
            </div>
            <div class="zn-summary-item">
              <div class="form-control-container">
                <label class="form-label" for="standDivisionOriginalArea">
                  {{ (localizationKeyPrefix + '.Fields.NewArea') | abpLocalization }}
                  <span class="form-label-required">*</span>
                </label>
                <input
                  id="standDivisionOriginalArea"
                  class="form-control"
                  type="number"
                  min="0.01"
                  step="0.01"
                  inputmode="decimal"
                  [value]="originalStandAreaInput() ?? ''"
                  [placeholder]="`${localizationResource}::EnterNumber` | abpLocalization"
                  (input)="onOriginalAreaInput($any($event.target).value)"
                />
              </div>
            </div>
            <div >
              <lib-stand-gis
                [canFetchGisArea]="canFetchOriginalGisArea()"
                [name]="selectedStand()?.name ?? ''"
                (updatedGisArea)="onOriginalGisAreaUpdated($event)"
              ></lib-stand-gis>
            </div>
          </div>

          <div >
            <zn-button
              type="primary"
              size="normal"
              [disabled]="!canConfirmOriginalStand()"
              [label]="(localizationKeyPrefix + '.Original.Confirm') | abpLocalization"
              (clicked)="confirmOriginalStand()"
            ></zn-button>
          </div>
        </div>
      } @else {
        <div class="zn-step-content-section-layout">
          <div class="zn-step-content-section-layout">
            <div class="zn-summary-item">
              <div class="form-control-container">
                <label class="form-label" for="standDivisionNewStand">
                  {{ (localizationKeyPrefix + '.Fields.NewStand') | abpLocalization }}
                  <span class="form-label-required">*</span>
                </label>
                <input
                  id="standDivisionNewStand"
                  class="form-control"
                  type="text"
                  [value]="newStandName()"
                  [placeholder]="`${localizationResource}::EnterText` | abpLocalization"
                  (input)="onNewStandNameInput($any($event.target).value)"
                />
              </div>
            </div>
            <div class="zn-summary-item">
              <div class="form-control-container">
                <label class="form-label" for="standDivisionNewArea">
                  {{ (localizationKeyPrefix + '.Fields.NewArea') | abpLocalization }}
                  <span class="form-label-required">*</span>
                </label>
                <input
                  id="standDivisionNewArea"
                  class="form-control"
                  type="number"
                  min="0.01"
                  step="0.01"
                  inputmode="decimal"
                  [value]="newStandAreaInput() ?? ''"
                  [placeholder]="`${localizationResource}::EnterNumber` | abpLocalization"
                  (input)="onNewStandAreaInput($any($event.target).value)"
                />
              </div>
            </div>
            <div >
              <lib-stand-gis
                [canFetchGisArea]="canFetchNewStandGisArea()"
                [name]="newStandName()"
                (updatedGisArea)="onNewStandGisAreaUpdated($event)"
              ></lib-stand-gis>
            </div>
          </div >
            <div >
            <zn-button
              type="primary"
              size="normal"
              [disabled]="!canConfirmNewStand()"
              [label]="(localizationKeyPrefix + '.ResultingForm.Confirm') | abpLocalization"
              (clicked)="addResultingStand()"
            ></zn-button>
          </div>
        </div>
      }
    </div>
  </div>

  <div [class]="tableSectionClass()">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Table.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Table.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-table" [class.zn-table--empty]="allRows().length === 0">
        <div class="zn-table-scroll">
          <table class="zn-table-element">
            <thead>
              <tr>
                <th>{{ 'Planning::Entity.Stand' | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.OriginalArea') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.NewArea') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Table.Columns.Type') | abpLocalization }}</th>
              </tr>
            </thead>
            <tbody>
              @if (allRows().length === 0) {
                <tr>
                  <td class="zn-table-empty" colspan="4">
                    {{ (localizationKeyPrefix + '.Table.Empty') | abpLocalization }}
                  </td>
                </tr>
              }

              @for (row of allRows(); track row.id) {
                <tr [class.zn-row--original]="row.type === 'original'">
                  <td>
                    <div class="zn-action-container">
                      <button
                        class="btn btn-tertiary btn-sm btn-delete"
                        type="button"
                        [disabled]="row.type === 'original' || editingRowId() !== null"
                        (click)="removeResultingStand(row.id)"
                      >
                        <i class="bi bi-trash3"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-tertiary btn-edit p-0"
                        [disabled]="editingRowId() !== null"
                        (click)="editStand(row)"
                      >
                        <i class="bi bi-pencil"></i>
                      </button>
                      <span>{{ row.name }}</span>
                    </div>
                  </td>
                  <td>{{ formatArea(rowOriginalArea(row)) }}</td>
                  <td>{{ formatArea(rowNewArea(row)) }}</td>
                  <td class="stand-resulting-row-type">{{ rowTypeLabelKey(row) | abpLocalization }}</td>
                </tr>
              }

              @if (allRows().length > 0) {
                <tr class="zn-resume">
                  <td>{{ (localizationKeyPrefix + '.Table.Total') | abpLocalization }}</td>
                  <td>
                    <span class="zn-total-input">{{ formatArea(originalStandArea()) }}</span>
                  </td>
                  <td>
                    <span class="zn-total-input">{{ formatArea(totalArea()) }}</span>
                  </td>
                  <td></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
